var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import { truncateStyle } from '../../customCSS';
export default {
    root: function (_a) {
        var _b = _a.props, atMention = _b.atMention, color = _b.color, disabled = _b.disabled, error = _b.error, important = _b.important, size = _b.size, success = _b.success, temporary = _b.temporary, timestamp = _b.timestamp, truncated = _b.truncated, weight = _b.weight, v = _a.variables;
        return __assign({ display: 'inline-block' }, (atMention === true && {
            color: v.atMentionOtherColor,
        }), (atMention === 'me' && {
            color: v.atMentionMeColor,
        }), (truncated && truncateStyle), (color && { color: _.get(v.colors, color) }), (disabled && { color: v.disabledColor }), (error && { color: v.errorColor }), (success && { color: v.successColor }), (important && { color: v.importantColor }), (temporary && { fontStyle: 'italic' }), (timestamp && { color: v.timestampColor }), (weight === 'light' && {
            fontWeight: v.fontWeightLight,
        }), (weight === 'semilight' && {
            fontWeight: v.fontWeightSemilight,
        }), (weight === 'regular' && {
            fontWeight: v.fontWeightRegular,
        }), (weight === 'semibold' && {
            fontWeight: v.fontWeightSemibold,
        }), (weight === 'bold' && {
            fontWeight: v.fontWeightBold,
        }), (size === 'smaller' && {
            fontSize: v.fontSizeExtraSmall,
            lineHeight: v.fontLineHeightExtraSmall,
        }), (size === 'small' && {
            fontSize: v.fontSizeSmall,
            lineHeight: v.fontLineHeightSmall,
        }), (size === 'medium' && {
            fontSize: v.fontSizeMedium,
            lineHeight: v.fontLineHeightMedium,
        }), (size === 'large' && {
            fontSize: v.fontSizeLarge,
            lineHeight: v.fontLineHeightLarge,
        }), (size === 'larger' && {
            fontSize: v.fontSizeExtraLarge,
            lineHeight: v.fontLineHeightExtraLarge,
        }));
    },
};
